import React from "react";
import Space from "../../commons/Space";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Titolo from "../../commons/Titolo";
import foto from "../../images/Nuoto/Master/DSCF9116.jpg";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import TitoloSezioni from "../../commons/TitoloSezioni";
import giugno from "../../images/Nuoto/Master/Aggiornamento GIUGNO 2024_page-0001.jpg"
import maggio3 from "../../images/Nuoto/Master/Aggiornamento MAGGIO 2024_page-0003.jpg"
import maggio2 from "../../images/Nuoto/Master/Aggiornamento MAGGIO 2024_page-0002.jpg"
import maggio1 from "../../images/Nuoto/Master/Aggiornamento MAGGIO 2024_page-0001.jpg"
import aprile1 from "../../images/Nuoto/Master/Aggiornamento Aprile 2024_page-0001.jpg";
import aprile2 from "../../images/Nuoto/Master/Aggiornamento Aprile 2024_page-0002.jpg";
import marzo from "../../images/Nuoto/Master/Aggiornamento Marzo 2024_page-0001.jpg";
import febbraio from "../../images/Nuoto/Master/Aggiornamento Febbraio 2024_page-0001.jpg";
import dicembre from "../../images/Nuoto/Master/Aggiornamento Dicembre 2023_page-0001.jpg";
import gennaio1 from "../../images/Nuoto/Master/Aggiornamento Gennaio 2024_page-0001.jpg";
import gennaio2 from "../../images/Nuoto/Master/Aggiornamento Gennaio 2024_page-0002.jpg";
import novembre1 from "../../images/Nuoto/Master/Saronno_Novembre2023.jpg";
import novembre2 from "../../images/Nuoto/Master/Gonzaga_Novembre2023.jpg";
import foto1 from "../../images/Nuoto/Master/DSCF9126.jpg"
import foto2 from "../../images/Nuoto/Master/SwimmicupXmasEd2024-0338.jpg"
import foto3 from "../../images/Nuoto/Master/DSCF9139.jpg"
import foto4 from "../../images/Nuoto/Master/SwimmicupXmasEd2024-0608.jpg"
import 'bs5-lightbox';
import SpaceL from "../../commons/SpaceL";
import { Link } from "react-router-dom"; // Importa il componente Link da react-router-dom
import "../../styles/Master.css";
import CaroselloStandard from "../../commons/CaroselloStandard";

function Master() {
    return (
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto} title={"Master"} />
            <FrecciaIndietro indirizzo={"/piscina"} />
            <div style={{padding: "1em"}}>
                <h3 className="text-center" style={{padding: "1em"}}>Risultati Gare</h3>

            <div className="d-flex flex-row container" style={{ overflowX: "auto" }}>
                <img src={giugno} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={maggio3} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={maggio2} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={maggio1} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={aprile2} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={aprile1} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={marzo} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={febbraio} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={gennaio2} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={gennaio1} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={dicembre} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={novembre2} className="img-fluid img-thumbnail master-ris" alt="..." />
                <img src={novembre1} className="img-fluid img-thumbnail master-ris" alt="..." />
            </div>
            <Space />
            <div className="text-center">
                <a href="https://www.federnuoto.it/home/master/circuito-supermaster/eventi-circuito-supermaster.html" target="_blank" rel="noopener noreferrer" className="text-center" style={{ fontSize: "22px", padding: "1em", fontFamily: "Hammersmith One", color: "#032041" }}> Prossime gare </a>
            </div>

            <Space />
            <Space />

            <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4} />

            <Space />
            </div>
        </div>
    )
}

export default Master;
